// extracted by mini-css-extract-plugin
module.exports = {"homeContainer":"Home_homeContainer__11XYm","warning":"Home_warning__1se3u"};